"use strict";

exports.__esModule = true;
exports.Icon = void 0;

var _styled = require("@manifest-ui/styled");

const Icon = (0, _styled.styled)('svg', {
  label: 'Icon',
  themeKey: 'icon'
})(({
  size
}) => ({
  color: 'inherit',
  display: 'inline-block',
  flexShrink: 0,
  fill: 'currentColor',
  fontSize: size,
  height: size,
  userSelect: 'none',
  width: size
}));
exports.Icon = Icon;
Icon.defaultProps = {
  size: '24px',
  viewBox: '0 0 24 24'
};